import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useLocalStorage } from "../../hooks/useStorage";
import { Button } from "../Button";
import { useContentGateRestrictions } from "../ContentGate/hooks/useContentGateRestrictions";
import { Dialog } from "../Dialog";
import { Typography } from "../Typography";
import styles from "./LoyaltySoftGatePopup.module.scss";
const localStorageKey = "loyaltySoftGatePopup.choice";
export const LoyaltySoftGatePopup = ({ logoSrc, title, okBtnTitle, noBtnTitle, noBtnLink, restrictions, }) => {
    const { setStorage, getStorage } = useLocalStorage();
    const [userChoice, setUserChoice] = useState(() => getStorage(localStorageKey, false));
    const { isDialogOpen } = useContentGateRestrictions(restrictions);
    const onYesClick = () => {
        setStorage(localStorageKey, true);
        setUserChoice(true);
    };
    if (!isDialogOpen || userChoice) {
        return null;
    }
    return (_jsx(Dialog, { isOpened: true, closable: false, noPadding: true, dataTestId: "LoyaltySoftGatePopup", children: _jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.logoWrapper, children: _jsx("img", { src: logoSrc, alt: "logo" }) }), _jsx(Typography, { variant: "body1", weight: "light", children: title }), _jsxs("div", { className: styles.btns, children: [_jsx(Button, { color: "secondary", href: noBtnLink, children: noBtnTitle }), _jsx(Button, { onClick: onYesClick, children: okBtnTitle })] })] }) }));
};
//# sourceMappingURL=LoyaltySoftGatePopup.js.map